module.exports = __webpack_public_path__ + "static/media/ZCO.63f2ae96.pdf";